import React, { useEffect, useState } from "react";
import ContactInfoModal from "./ContactInfoModal/ContactInfoModal";
import AcademicInfoModal from "./AcademicInfoModal/AcademicInfoModal";
import WorkExperienceInfoModal from "./WorkingExperienceInfoModal/WorkExperienceInfoModal";
import ProjectInfoModal from "./ProjectInfoModal/ProjectInfoModal";
import HobbyInfoModal from "./HobbyInfoModal/HobbyInfoModal";
import InstructionInfoModal from "./InstructionInfoModal/InstructionInfoModal";
import SkillsInfoModal from "./SkillsInfoModal/SkillsInfoModal";
import SpeechBubbleModal from "./SpeechBubbleModal/SpeechBubbleModal";
const Modal = (props) => {
  const [modalID, setModalID] = useState(0);
  const [show, SetShow] = useState(false);

  useEffect(() => {
    setModalID(props.modalID);
    SetShow(props.show);
  }, [props]);
  return (
    <>
      {modalID === 1 ? (
        <ContactInfoModal show={show} onHide={props.onHide} />
      ) : null}
      {modalID === 2 ? (
        <AcademicInfoModal show={show} onHide={props.onHide} />
      ) : null}
      {modalID === 3 ? (
        <ProjectInfoModal show={show} onHide={props.onHide} />
      ) : null}
      {modalID === 4 ? (
        <WorkExperienceInfoModal show={show} onHide={props.onHide} />
      ) : null}
      {modalID === 5 ? (
        <HobbyInfoModal show={show} onHide={props.onHide} />
      ) : null}
      {modalID === 6 ? (
        <InstructionInfoModal show={show} onHide={props.onHide} />
      ) : null}
      {modalID === 7 ? (
        <SkillsInfoModal show={show} onHide={props.onHide} />
      ) : null}
      {modalID === 8 ? (
      <SpeechBubbleModal show={show} onHide={props.onHide} />
    ) : null}
    </>
  );
};

export default Modal;
